module.exports = __webpack_public_path__ + "media/src/website/images/locations/felden/felden_01-e9480fc9b86bef4080ec0da91586f0db.jpg";